<template>
  <div>
    <ul class="nav nav-tabs nav-fill">
      <li class="nav-item">
        <router-link :to="`/company/${$route.params.id}/details`" class="nav-link">
          Details
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="`/company/${$route.params.id}/contacts`" class="nav-link">
          Contacts
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="`/company/${$route.params.id}/addresses`" class="nav-link">
          Addresses
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="`/company/${$route.params.id}/shippingaccounts`" class="nav-link">
          Shipping Accounts
        </router-link>
      </li>
      <li class="nav-item">
        <router-link  :to="`/company/${$route.params.id}/financial`" class="nav-link">
          Financial
        </router-link>
      </li>
      <li class="nav-item">
        <router-link  :to="`/company/${$route.params.id}/orderfullfillment`" class="nav-link">
          Order Fulfillment
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="`/company/${$route.params.id}/documents`" class="nav-link">
          Documents
        </router-link>
      </li>
      <li v-if="isVendor" class="nav-item">
        <router-link :to="`/company/${$route.params.id}/manufacturers`" class="nav-link">
          Manufacturers
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="`/company/${$route.params.id}/history`" class="nav-link">
          History
        </router-link>
      </li>
    </ul>
    <!--<router-link :to="`/company`" class="btn close pull-right">
      <i class="fa fa-times" aria-hidden="true"></i>
    </router-link>-->
    <div class="tab-content">
      <div class="tab-pane active">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'UpperTab',
  props: {
    isVendor: {
      type: Boolean,
      default: false,
    }
  }
};
</script>
